<div class="layout">
  <app-sidenav [(drawerVisible)]="drawerVisible"></app-sidenav>

  <div class="content">
    <app-header (toggleSidebar)="toggleDrawer()" class="header"></app-header>

    <main class="px-3">
      <app-spinner-component />
      <router-outlet></router-outlet>
    </main>
  </div>
</div>